/** @module Enums */ /** typedoc */
var AssetPurchaseFormatEnum;
(function (AssetPurchaseFormatEnum) {
    AssetPurchaseFormatEnum["upsell"] = "CTA_SaaS_ALC";
    AssetPurchaseFormatEnum["lomp3"] = "lomp3";
    AssetPurchaseFormatEnum["himp3"] = "himp3";
    AssetPurchaseFormatEnum["wav"] = "wav";
    AssetPurchaseFormatEnum["hdwav"] = "hdwav";
})(AssetPurchaseFormatEnum || (AssetPurchaseFormatEnum = {}));

export { AssetPurchaseFormatEnum };
